"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MicroFeedback_vue_1 = __importDefault(require("./MicroFeedback.vue"));
let SubclientsListItem = class SubclientsListItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.animationTriggered = false;
    }
    copy(code) {
        navigator.clipboard.writeText(code);
        this.animationTriggered = true;
    }
    resetAnimation() {
        this.animationTriggered = false;
    }
    emitActionButton(crop) {
        if (!crop) {
            if (this.subclient.crop.length < 1) {
                this.$emit('actionSubclientListItem', true, this.subclient, 'no_crop');
            }
            else {
                for (const crop of this.subclient.crop) {
                    if (crop.logo_name === this.currentCrop) {
                        this.$emit('actionSubclientListItem', true, this.subclient, crop);
                        return;
                    }
                    else {
                        this.$emit('actionSubclientListItem', true, this.subclient, this.subclient.crop[0]);
                    }
                }
            }
        }
        else {
            this.$emit('actionSubclientListItem', true, this.subclient, crop);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: 'https://bmk-public-assets.s3.amazonaws.com/bmk-ui-framework/profile/default.jpg',
    })
], SubclientsListItem.prototype, "imgSrc", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], SubclientsListItem.prototype, "subclient", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], SubclientsListItem.prototype, "currentCrop", void 0);
SubclientsListItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'SubclientsListItem',
        components: { Button: bmk_ui_framework_1.Button, ArrowRightIcon: bmk_ui_framework_1.ArrowRightIcon, MicroFeedback: MicroFeedback_vue_1.default },
    })
], SubclientsListItem);
exports.default = SubclientsListItem;
